import { render } from "./AnimationsBallAnimationMain.vue?vue&type=template&id=e5589f2e&scoped=true&ts=true"
import script from "./AnimationsBallAnimationMain.vue?vue&type=script&lang=ts"
export * from "./AnimationsBallAnimationMain.vue?vue&type=script&lang=ts"

import "./AnimationsBallAnimationMain.vue?vue&type=style&index=0&id=e5589f2e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5589f2e"]])

export default __exports__